import { useImperativeHandle, useRef } from 'react';

import { COPY_EXCLUDE_SELECTOR } from '../MarkdownRenderer.constants';

import type { MarkdownRendererRef } from '../MarkdownRenderer';
import type { ForwardedRef, RefObject } from 'react';

export const useMarkdownCopyRef = (
  ref: ForwardedRef<MarkdownRendererRef>,
): RefObject<HTMLDivElement> => {
  const containerRef = useRef<HTMLDivElement>(null);

  useImperativeHandle(ref, () => ({
    getHtmlContent: (): string => {
      if (!containerRef.current) return '';
      const clone = containerRef.current.cloneNode(true) as HTMLElement;
      // Citation chips are left in place: they record which source they stand
      // for, and `sanitizeHtmlForCopy` either turns them into `[N]` markers or
      // drops them with the rest of the copy-excluded chrome.
      clone
        .querySelectorAll(`${COPY_EXCLUDE_SELECTOR}:not([data-citation-url])`)
        .forEach((el) => el.remove());
      return clone.innerHTML;
    },
    getPlainText: (): string => {
      if (!containerRef.current) return '';
      const clone = containerRef.current.cloneNode(true) as HTMLElement;
      clone
        .querySelectorAll(COPY_EXCLUDE_SELECTOR)
        .forEach((el) => el.remove());
      return clone.innerText || clone.textContent || '';
    },
  }));

  return containerRef;
};
